"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var colors_1 = require("../util/colors");
var grid_1 = require("./grid");
var spacing_1 = require("./spacing");
var CardHolder = (0, styled_components_1.default)(grid_1.Item)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-self: stretch;\n"], ["\n  align-self: stretch;\n"])));
var Card = (0, styled_components_1.default)(spacing_1.Div)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n\n  box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.15);\n  border-radius: 16px;\n  background-color: ", ";\n"], ["\n  width: 100%;\n  height: 100%;\n\n  box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.15);\n  border-radius: 16px;\n  background-color: ", ";\n"])), function (_a) {
    var color = _a.color;
    return color;
});
var TestimonialCard = function (_a) {
    var _b = _a.cardColor, cardColor = _b === void 0 ? colors_1.colors.white : _b, children = _a.children;
    return (react_1.default.createElement(CardHolder, { pb: 3, px: 3, cols: 4, smCols: 12 },
        react_1.default.createElement(Card, { px: 3, py: 5, color: cardColor }, children)));
};
exports.default = TestimonialCard;
var templateObject_1, templateObject_2;
//# sourceMappingURL=TestimonialCard.js.map